import FieldReadOnly from "../../../generic/read-only-value/read-only"
import FieldConfig from "../../../../fields3/proto/field-config"
import {SortDirection} from "../../../../data-structures/sort"
import ItemModelV2 from "../../../../model2/item2/item-model"

export default class FieldTimeReportTaskId extends FieldReadOnly {

    constructor(config: FieldConfig) {
        super(config)

        this.icon = 'i5-id'
    }

    listItemSortFunctions(direction: SortDirection) {
        return {
            functions  : [(listItem: ItemModelV2) => {
                const shortId = listItem.timeReport?.task?.shortId
                return shortId ? Number(shortId) : 0
            }],
            directions : [direction]
        }
    }
}
